import { PaperDimensions } from '../types/paper-dimensions.type';

export function calculateNumberOfRowsPerPage(
  paperDimensions: PaperDimensions,
  topMargin: number,
  bottomMargin: number,
  labelHeight: number,
  labelGutterHeight: number,
) {
  const canvasHeight = paperDimensions.height - bottomMargin - topMargin;
  const labelHeightIncludingBottomGutter = labelHeight + labelGutterHeight;
  const maxNumberOfRows = Math.floor(
    canvasHeight / labelHeightIncludingBottomGutter,
  );

  return maxNumberOfRows;
}
